"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVATE_TARIFF_RESPONSE_EXAMPLE = void 0;
const financial_common_response_1 = require("./financial-common.response");
exports.ACTIVATE_TARIFF_RESPONSE_EXAMPLE = {
    tariff: financial_common_response_1.FIN_TARIFF_RESPONSE_EXAMPLE,
    notificationSent: false,
};
//# sourceMappingURL=financial-tariff.response.js.map